// 开发环境：craco devServer proxy 转发到 ivelly
// 生产环境：Cloudflare Pages Functions 代理
const devBaseURL = `/api/`
const proBaseURL = `/api/`

const TIMEOUT = 10000

const BASE_URL = process.env.NODE_ENV === 'development' ? devBaseURL : proBaseURL

export { TIMEOUT, BASE_URL }
